import { render, staticRenderFns } from "./MenuCategories.vue?vue&type=template&id=3a4db15c&scoped=true&"
import script from "./MenuCategories.vue?vue&type=script&lang=js&"
export * from "./MenuCategories.vue?vue&type=script&lang=js&"
import style0 from "./MenuCategories.vue?vue&type=style&index=0&id=3a4db15c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4db15c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconFilter: require('/opt/build/repo/components/icons/IconFilter.vue').default,CheckboxChecked: require('/opt/build/repo/components/icons/CheckboxChecked.vue').default,CheckboxUnchecked: require('/opt/build/repo/components/icons/CheckboxUnchecked.vue').default,IconArrowRight: require('/opt/build/repo/components/icons/IconArrowRight.vue').default})
